import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TriggerDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        minWidth: 0
    },
    text: {
        flexShrink: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    controlPaddings,
    spaces
}: TriggerDynamicStyleType) => {
    const styles = {
        container: {
            columnGap: controlPaddings.small,
            rowGap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
